import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const CustomDialog = styled(Dialog)`
	& .MuiDialog-paper {
		padding: 30px;
	}
`;

const CustomDialogTitle = styled(DialogTitle)`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 15px;
`;

const CustomDialogContent = styled(DialogContent)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	text-align: center;
`;

const EmailContainer = styled(DialogContent)`
	border: 1px dashed blue;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
	margin-bottom: 1rem;
	max-height: 20vh;
	max-width: 100%;
	overflow-y: scroll;
	overflow-wrap: break-word;
`;

export default {
	CustomDialog,
	CustomDialogTitle,
	CustomDialogContent,
	EmailContainer
};
